import { DispositionAddressResponseItem, DispositionAddressResponse } from '@/types/service-response'

export class DispositionAddress {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: DispositionAddressResponse): Array<DispositionAddress> {
    let result: Array<DispositionAddress> = []
    if (responseData) {
      result = responseData.map((item: DispositionAddressResponseItem ) => {
        return new DispositionAddress(
          item.ID,
          item.Name
        )
      })
    }
    return result
  }
}